import { ConnectedAcquiringReport } from 'widgets/report/acquiring';

export function AcquiringReportPage() {
  return <ConnectedAcquiringReport />;
}
